'use client';

import NextLink from 'next/link';
import { useTranslations, useLocale } from 'next-intl';
import {
  Box,
  Container,
  Typography,
  Button,
  Divider,
  Paper,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { LandingHeader, LandingFooter } from '../../../features/landing';
import { HelpCenter } from '../../../features/help-center';
import { getConsumerUrl } from '../../../lib/consumerUrl';
import { getHelpBotSlug } from '../../../lib/helpBot';

export function HelpCenterContent() {
  const t = useTranslations('creator.helpCenter');
  const locale = useLocale();
  const consumerUrl = getConsumerUrl();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <LandingHeader />

      <Container maxWidth="md" sx={{ py: { xs: 4, md: 6 }, flex: 1 }}>
        {/* Page Title */}
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 700,
            mb: 2,
            textAlign: 'center',
          }}
        >
          {t('title')}
        </Typography>
        <Typography
          variant="h6"
          component="p"
          sx={{
            color: 'text.secondary',
            mb: 4,
            textAlign: 'center',
            fontWeight: 400,
          }}
        >
          {t('subtitle')}
        </Typography>

        {/* Ask Boty CTA */}
        <Paper
          elevation={0}
          id="ask-boty"
          sx={{
            p: { xs: 3, md: 4 },
            mb: 4,
            bgcolor: 'primary.50',
            borderRadius: 2,
            border: 1,
            borderColor: 'primary.100',
            textAlign: 'center',
          }}
        >
          <SmartToyIcon color="primary" sx={{ fontSize: 48, mb: 1 }} />
          <Typography variant="h5" component="h2" sx={{ fontWeight: 600, mb: 1 }}>
            {t('askBoty')}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            {t('askBotyDescription')}
          </Typography>
          <Button
            variant="contained"
            size="large"
            href={`${consumerUrl}/${locale}/${getHelpBotSlug(locale)}`}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<SmartToyIcon />}
            sx={{ textTransform: 'none' }}
          >
            {t('askBotyButton')}
          </Button>
        </Paper>

        {/* Help Sections */}
        <HelpCenter />

        <Divider sx={{ my: 4 }} />

        {/* Back to Home */}
        <Box sx={{ textAlign: 'center' }}>
          <Button
            component={NextLink}
            href={`/${locale}`}
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            size="large"
            sx={{ textTransform: 'none' }}
          >
            {t('backToHome')}
          </Button>
        </Box>
      </Container>

      <LandingFooter />
    </Box>
  );
}
